<app-protected-content [requiredRoles]="requiredRoles" [requireApprovedOrganization]="true">
  <div class="container" *transloco="let t; prefix: 'organization.edit'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToDetail()">{{
      'button.back' | transloco
    }}</htx-button>

    <div class="panel">
      <div class="edit-header">
        <div class="header-title-section">
          <h1 class="header-title">{{ t('header') }}</h1>
          <p class="header-subtitle">{{ t('subtitle') }}</p>
        </div>
        <htx-button variant="tertiary" icon="save" (click)="save()" [disabled]="form.invalid">
          {{ 'button.save' | transloco }}
        </htx-button>
      </div>

      <div class="form-sections">
        <!-- Hint for OrgAdmin: sensitive fields are managed by DSA -->
        @if (isOrgEditor && !isDataspaceAuthority) {
          <htx-alert
            variant="info"
            [title]="t('disabledFieldsHint.title')"
            [message]="t('disabledFieldsHint.message')"
          ></htx-alert>
        }

        <htx-form-section
          [title]="t('sections.organizationInfo')"
          [icon]="'domain'"
          [formGroup]="form"
          [fieldLabels]="fieldLabels"
        >
          <htx-text-field-with-error
            [ctrl]="form.controls.legalName"
            [label]="t('controls.legalName.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.shortName"
            [label]="t('controls.shortName.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.legalForm"
            [label]="t('controls.legalForm.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.sector"
            [label]="t('controls.sector.label')"
          >
          </htx-text-field-with-error>
        </htx-form-section>

        <htx-form-section
          [title]="t('sections.contactWeb')"
          [icon]="'language'"
          [formGroup]="form"
          [fieldLabels]="fieldLabels"
        >
          <htx-text-field-with-error
            [ctrl]="form.controls.website"
            [label]="t('controls.website.label')"
          >
          </htx-text-field-with-error>
        </htx-form-section>

        <htx-form-section
          [title]="t('sections.address')"
          [icon]="'location_on'"
          [formGroup]="form"
          [fieldLabels]="fieldLabels"
        >
          <htx-text-field-with-error
            [ctrl]="form.controls.street"
            [label]="t('controls.street.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.houseNumber"
            [label]="t('controls.houseNumber.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.postalCode"
            [label]="t('controls.postalCode.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.city"
            [label]="t('controls.city.label')"
          >
          </htx-text-field-with-error>
        </htx-form-section>

        <htx-form-section
          [title]="t('sections.registrationData')"
          [icon]="'assignment'"
          [formGroup]="form"
          [fieldLabels]="fieldLabels"
        >
          <htx-text-field-with-error
            [ctrl]="form.controls.commercialRegisterNumber"
            [label]="t('controls.commercialRegisterNumber.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.commercialRegisterCourt"
            [label]="t('controls.commercialRegisterCourt.label')"
          >
          </htx-text-field-with-error>
          <htx-text-field-with-error
            [ctrl]="form.controls.taxIdNumber"
            [label]="t('controls.taxIdNumber.label')"
          >
          </htx-text-field-with-error>
          <htx-datepicker-field-with-error
            [ctrl]="form.controls.foundingDate"
            [label]="t('controls.foundingDate.label')"
          >
          </htx-datepicker-field-with-error>
        </htx-form-section>

        <htx-form-section
          [title]="t('sections.description')"
          [icon]="'description'"
          [formGroup]="form"
          [fieldLabels]="fieldLabels"
        >
          <htx-textarea-field-with-error
            [ctrl]="form.controls.description"
            [label]="t('controls.description.label')"
          >
          </htx-textarea-field-with-error>
        </htx-form-section>

        <!-- Status & DID section (only visible for Dataspace Authority) -->
        @if (isDataspaceAuthority) {
          <htx-form-section
            [title]="t('sections.statusDid')"
            [icon]="'admin_panel_settings'"
            [formGroup]="form"
            [fieldLabels]="fieldLabels"
          >
            @if (showDidWarning()) {
              <htx-alert
                variant="warning"
                [title]="t('didWarning.title')"
                [message]="t('didWarning.message')"
              ></htx-alert>
            }

            <htx-text-field-with-error
              [ctrl]="form.controls.did"
              [label]="t('controls.did.label')"
            ></htx-text-field-with-error>

            <htx-dropdown-field
              [ctrl]="form.controls.activityState"
              [label]="t('controls.activityState.label')"
              [options]="statusOptions()"
            ></htx-dropdown-field>
          </htx-form-section>
        }
      </div>

      <div class="form-footer">
        <htx-button variant="primary" icon="save" (click)="save()" [disabled]="form.invalid">
          {{ 'button.save' | transloco }}
        </htx-button>
      </div>
    </div>
  </div>
</app-protected-content>
